import * as React from "react";
import StatAttribute from "../StatAttribute/StatAttribute";
import {toRoman} from "../../helpers/helpers";
import PackageButton from "../PackageSelector/PackageButton/PackageButton";
import TankComponent from "../TankComponent/TankComponent";

export default class ModuleSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gunCompatible: true,
            turretCompatible: true,
        };
    };

    render() {
        let ARROW_CLASS = "tank-config_arrow";
        let LEVEL_CLASS = "tank-config_level";

        const componentData = this.props.componentData;
        let level = componentData.level,
            newLevel = componentData.newLevel;
        let currentLevel = level;

        if (newLevel && newLevel !== currentLevel) {
            if (newLevel > level) {
                ARROW_CLASS += " " + ARROW_CLASS + "__up";
                LEVEL_CLASS += " " + LEVEL_CLASS + "__up";
            } else {
                ARROW_CLASS += " " + ARROW_CLASS + "__down";
                LEVEL_CLASS += " " + LEVEL_CLASS + "__down";
            }
            currentLevel = newLevel;
        }

        if (this.props.tank_module === "guns") {
            // check if current gun index name is in turrets list of guns
            let compatibleTurrets = componentData[this.props.currentComponentIndex].turret_names;
            // fine selected turret name
            let selectedTurretName = vehicle.unlock_progression.turrets[this.props.currentTurrentIndex].name;

            if (compatibleTurrets.includes(selectedTurretName)) {
                this.state.gunCompatible = true;
            } else {
                this.state.gunCompatible = false;
            };
        }

        if (this.props.tank_module === "turrets") {
            // check if current gun index name is in turrets list of guns
            let compatibleGuns = componentData[this.props.currentComponentIndex].gun_names;
            // find selected gun name
            let selectedGunName = vehicle.unlock_progression.guns[this.props.currentGunIndex].name;
            if (compatibleGuns.includes(selectedGunName)) {
                this.state.turretCompatible = true;
            } else {
                this.state.turretCompatible = false;
            };
        }

        let multigunEnabled = this.props.multigunEnabled && this.props.tank_module == "guns";
        let unlockProgressionGunIndex = [];
        let gunIndexValue = {};
        let groupingDict = {};
        let gunLevel = {};

        // Parsing vehicle.guns for group ordering and separators
        for(let gunName in vehicle.guns) {
            for(let [index, gunInfo] of vehicle.unlock_progression.guns.entries()) {
                let name = gunInfo.name;
                let level = gunInfo.level;
                if(gunName == name) {
                    let grouping = vehicle.guns[gunName].grouping;
                    gunIndexValue[gunName] = index;
                    gunLevel[gunName] = [level];
                    gunLevel[gunName].push(grouping)
                }
            }
            let grouplisting_index = gunIndexValue[gunName]
            unlockProgressionGunIndex[grouplisting_index] = gunName
        };
        let unlockProgressionOrdering = [];
        for(let [index, gunInfo] of vehicle.unlock_progression.guns.entries()) {
            let name = gunInfo.name;
            let gunGrouping = vehicle.guns[name].grouping;
            unlockProgressionOrdering.push(name)
            if(gunGrouping in groupingDict){
                groupingDict[gunGrouping].push(name);
            } else {
                groupingDict[gunGrouping] = [name]
            }

        }
        // Have groupings ordered at this point
        // Process two separate return renders for gun vs other modules
        // This case render/return is specific to Gun Modules
         if(multigunEnabled) {
             return (
                 <div className="tank-config module_selection">
                     {
                         Object.keys(unlockProgressionOrdering).map(attributeName => {
                             let moduleName = unlockProgressionOrdering[attributeName];
                             let value = gunIndexValue[moduleName];
                             let isActive = this.props.currentComponentIndex == value;
                             let currentGunLevel = gunLevel[moduleName][0];
                             let currentGrouping = gunLevel[moduleName][1];
                             let moduleGroupIndex = 0;
                             if(currentGunLevel != 0) {
                                 moduleGroupIndex = groupingDict[currentGrouping].indexOf(moduleName);
                             }

                             // Add hidden classname when separator detected
                             let module_title_classname = "tank-config_module_title";
                             if(groupingDict[currentGrouping].indexOf(moduleName) != 0 && gunIndexValue[moduleName] != 0) {
                                 module_title_classname += " hidden";
                             };

                            return (
                                 <div key={moduleName}>
                                     <div className={module_title_classname}>
                                         <div className="tank-config_module_links">
                                             <div className="tank-config_module_label">
                                                 {this.props.title.toUpperCase()}
                                             </div>
                                         </div>
                                     </div>
                                     <div className="tank-config_item module_selection"
                                          key={moduleName}>
                                         <PackageButton
                                             setPackageSelect={this.props.setPackageSelect}
                                             setNewPackage={this.props.setNewPackage}
                                             removeNewPackage={this.props.removeNewPackage}
                                             setWarning={this.props.setWarning}
                                             moduleGroupIndex={moduleGroupIndex}
                                             value={value}
                                             icon={this.props.icon}
                                             key={moduleName}
                                             componentData={componentData}
                                             attributeName={value}
                                             moduleName={moduleName}
                                             tank_module={this.props.tank_module}
                                             isActive={isActive}
                                             gunCompatible={this.state.gunCompatible}
                                             turretCompatible={this.state.turretCompatible}
                                         />
                                     </div>
                                 </div>
                             )
                         })
                     }
                 </div>
             );
         } else if(this.props.tank_module == "turrets") {
             const turrets = ["turrets0", "turrets1", "turrets2", "turrets3"];
             return (
                 <div className="tank-config module_selection">
                     {
                         turrets.map(turretGroup => {
                             if(vehicle.data[turretGroup]){
                                 return (
                                     <div key={turretGroup}>
                                         <div className="tank-config_module_title">
                                             <div className="tank-config_module_links">
                                                 <div className="tank-config_module_label">
                                                     {this.props.title.toUpperCase()}
                                                 </div>
                                             </div>
                                         </div>
                                         {
                                             Object.keys(componentData).map(attributeName => {
                                                 let moduleName = componentData[attributeName].name;
                                                 let isActive = this.props.currentComponentIndex == attributeName;
                                                 let moduleGroupIndex = 0;
                                                 for(let [index, moduleInfo] of vehicle.unlock_progression[this.props.tank_module].entries()) {
                                                    let name = moduleInfo.name;
                                                    let level = moduleInfo.level;
                                                    if(moduleName == name) {
                                                        if(level > 0) {
                                                            moduleGroupIndex = index;
                                                        }
                                                    }
                                                }
                                                 if(moduleName in vehicle.data[turretGroup]) {
                                                     let position = vehicle.data[turretGroup][moduleName].position;
                                                     return (
                                                         <div className="tank-config_item module_selection"
                                                              key={componentData[attributeName].name}>
                                                             <PackageButton
                                                                 setPackageSelect={this.props.setPackageSelect}
                                                                 setNewPackage={this.props.setNewPackage}
                                                                 removeNewPackage={this.props.removeNewPackage}
                                                                 setWarning={this.props.setWarning}
                                                                 moduleGroupIndex={moduleGroupIndex}
                                                                 value={attributeName}
                                                                 icon={this.props.icon}
                                                                 key={componentData[attributeName].name}
                                                                 componentData={componentData}
                                                                 attributeName={attributeName}
                                                                 moduleName={moduleName}
                                                                 tank_module={this.props.tank_module}
                                                                 isActive={isActive}
                                                                 gunCompatible={this.state.gunCompatible}
                                                                 turretCompatible={this.state.turretCompatible}
                                                                 position={position}
                                                             />
                                                         </div>
                                                     )
                                                 }
                                             })
                                         }
                                     </div>
                                 )
                             }
                         })
                     }
                 </div>
             )
         } else {
             return (
                 <div className="tank-config module_selection">
                     <div className="tank-config_module_title">
                         <div className="tank-config_module_links">
                             <div className="tank-config_module_label">
                                 {this.props.title.toUpperCase()}
                             </div>
                         </div>
                     </div>
                     {
                         Object.keys(componentData).map(attributeName => {
                             let moduleName = componentData[attributeName].name;
                             let isActive = this.props.currentComponentIndex == attributeName;

                             let moduleGroupIndex = 0;
                             for(let [index, moduleInfo] of vehicle.unlock_progression[this.props.tank_module].entries()) {
                                let name = moduleInfo.name;
                                let level = moduleInfo.level;
                                if(moduleName == name) {
                                    if(level > 0) {
                                        moduleGroupIndex = index;
                                    }
                                }
                            }

                             return (
                                 <div className="tank-config_item module_selection"
                                      key={componentData[attributeName].name}>
                                     <PackageButton
                                         setPackageSelect={this.props.setPackageSelect}
                                         setNewPackage={this.props.setNewPackage}
                                         removeNewPackage={this.props.removeNewPackage}
                                         setWarning={this.props.setWarning}
                                         moduleGroupIndex={moduleGroupIndex}
                                         value={attributeName}
                                         icon={this.props.icon}
                                         key={componentData[attributeName].name}
                                         componentData={componentData}
                                         attributeName={attributeName}
                                         moduleName={moduleName}
                                         tank_module={this.props.tank_module}
                                         isActive={isActive}
                                         gunCompatible={this.state.gunCompatible}
                                         turretCompatible={this.state.turretCompatible}
                                     />
                                 </div>
                             )
                         })
                     }
                 </div>
             )
         }
    }
}
